import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 3rem 3rem;
  margin-bottom: 25px;
  background-color: #071242;
`;
export const BannerContainer = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const BannerHeadling = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: baseline;
  justify-content: start;
  margin-bottom: 1.5rem;
`;
export const BannerHeader = styled.div`
  color: ${(params) => (params.light ? "#071242" : "#fff")};
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
`;
export const BannerDescription = styled.div`
  color: ${(params) => (params.light ? "#071242" : "#fff")};
  font-weight: 500;
  width: 100%;
  font-size: 1.8rem;
  @media screen and (max-width: 600px) {
    text-align: justify;
    width: 100%;
  } ;
`;
